import React from 'react'

import { Box } from '@mui/material'
import { AccountsPayableItem } from 'models/AccountsPayable'

import { Table } from 'components/Table'

import compositionDetailMapper from './utils'
interface ExpensesCompositionProps {
  items: AccountsPayableItem[]
}
const ExpenseComposition = ({ items }: ExpensesCompositionProps) => {
  return (
    <Box>
      <Box height="100px" overflow="auto">
        <Table
          mobileCards
          header={[
            { id: 'description', label: 'Descrição' },
            { id: 'amountUnit', label: 'Valor' },
            { id: 'quantity', label: 'Qtd.' },
            { id: 'amountBilled', label: 'Total' }
          ]}
          hoverInRow
          rows={compositionDetailMapper(items)}
          select={{ useSelect: false }}
          hiddePagination
        />
      </Box>
    </Box>
  )
}

export default ExpenseComposition
